import { Link } from "react-router-dom";
import { ShadowMark } from "./ShadowMark";
import { useDemoModal } from "./DemoModal";

export const DMG_URL =
  "https://github.com/Converse-AI-Inc/Shadow/releases/latest/download/Shadow.dmg";

// Top navigation shared across all site pages.
//   variant="dropdown" → the landing page nav (Solutions/Agents hover menus)
//   variant="flat"     → sub-page nav (plain links; `active` highlights the current item)
export default function SiteNav({ variant = "flat", active }) {
  const { openDemoModal } = useDemoModal();
  return (
    <nav>
      <div className="nav-inner">
        <Link className="logo" to="/">
          <ShadowMark size={26} />
          Shadow
        </Link>
        <div className="nav-links">
          {variant === "dropdown" ? (
            <>
              <a href="#product">Product</a>
              <div className="dd">
                <Link to="/solutions">Solutions</Link>
                <div className="dd-menu">
                  <Link to="/solutions#reps">For reps <span className="s">Sell with a staff behind you</span></Link>
                  <Link to="/solutions#managers">For managers <span className="s">Coach with evidence</span></Link>
                  <Link to="/solutions#cxos">For CXOs <span className="s">See why revenue moves</span></Link>
                </div>
              </div>
              <div className="dd">
                <Link to="/agents">Agents</Link>
                <div className="dd-menu">
                  <Link to="/agents#prep">Prep Desk <span className="s">Research, briefs, relationships, moments</span></Link>
                  <Link to="/agents#live">Live Desk <span className="s">Context, objections, discovery, storytelling</span></Link>
                  <Link to="/agents#back">Back Office <span className="s">Scribe, CRM, follow-ups, dispatch</span></Link>
                  <Link to="/agents#coaching">Coaching Staff <span className="s">Coach, workload, risk, forecast, ramp</span></Link>
                  <Link to="/agents#intel">Intelligence Desk <span className="s">Win/loss, market, voice of customer</span></Link>
                  <Link className="all" to="/agents">Meet all 26 agents &rarr;</Link>
                </div>
              </div>
              <Link to="/pricing">Pricing</Link>
              <Link to="/changelog">Changelog</Link>
              <Link to="/about">About</Link>
            </>
          ) : (
            <>
              <Link to="/#product" className={active === "product" ? "on" : undefined}>Product</Link>
              <Link to="/solutions" className={active === "solutions" ? "on" : undefined}>Solutions</Link>
              <Link to="/agents" className={active === "agents" ? "on" : undefined}>Agents</Link>
              <Link to="/pricing" className={active === "pricing" ? "on" : undefined}>Pricing</Link>
              <Link to="/changelog" className={active === "changelog" ? "on" : undefined}>Changelog</Link>
              <Link to="/about" className={active === "about" ? "on" : undefined}>About</Link>
            </>
          )}
        </div>
        <div className="nav-cta">
          <button className="btn btn-dark" onClick={() => openDemoModal({ context: "Nav" })}>Book a demo</button>
        </div>
      </div>
    </nav>
  );
}
